import { useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw } from 'draft-js';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Button, Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";


export default function NewNews() {
	const navigation = useNavigate();

	const [editorState, setEditorState] = useState<EditorState>(EditorState.createEmpty());
	const [title, setTitle] = useState("");
	const [publishDate, setPublishDate] = useState(new Date(new Date().setMinutes(0, 0, 0)));
	const [publishNow, setPublishNow] = useState(false);
	const [enableImage, setEnableImage] = useState(false);
	const [image, setImage] = useState<string | undefined>(undefined);
	const [file, setFile] = useState<File | undefined>(undefined);

	function onEditorStateChange(editorState: EditorState) {
		setEditorState(editorState);
	}

	async function onFileChange(e: React.ChangeEvent<HTMLInputElement>) {
		const file = e.target.files?.[0];
		setFile(file);
		if (!file) return;
		console.log(file);

		const res = await fetch(`${process.env.REACT_APP_API_URL}/presignedUrl`);
		const data = await res.json();

		const signedUrl = data.signedUrl;
		const imageUrl = data.imageUrl;

		await fetch(signedUrl, {
			method: 'PUT',
			body: file,
		});

		setImage(imageUrl);
	}

	function formSubmit(e: React.FormEvent<HTMLFormElement>) {
		e.preventDefault();
		onSubmit();
	}

	async function onSubmit() {
		const json = {
			title,
			publishAt: publishNow ? undefined : publishDate.toString(),
			content: convertToRaw(editorState.getCurrentContent()),
			imageUrl: enableImage ? image : undefined,
		};
		const res = await fetch(`${process.env.REACT_APP_API_URL}/news`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(json),
		});
		const data = await res.json();
		console.log(data);

		if (res.ok) {
			navigation('/news');
		}
	}

	console.log(editorState);
	console.log(convertToRaw(editorState.getCurrentContent()));
	console.log(JSON.stringify(convertToRaw(editorState.getCurrentContent())));

	return (
		<div className="container container-lg">
			<h1>Create News Post</h1>
			<Form onSubmit={formSubmit}>
				<Form.Group controlId="title" className="mb-3">
					<Form.Label>Title</Form.Label>
					<Form.Control type="text" placeholder="Enter title" value={title} onChange={e => setTitle(e.target.value)} />
				</Form.Group>
				<Editor
					editorState={editorState}
					toolbarClassName="toolbarClassName"
					wrapperClassName="wrapperClassName"
					editorClassName="editorClassName"
					onEditorStateChange={onEditorStateChange}
					wrapperStyle={{ border: "1px solid black", borderRadius: 5, padding: "5px" }}
				/>
				<Form.Group controlId="publishDate" className="mb-3" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
					<Form.Label>Publish Time</Form.Label>
					<Form.Check
						type={'checkbox'}
						label={`Publish Now`}
						checked={publishNow}
						onChange={(e) => setPublishNow(e.target.checked)}
					/>
					{!publishNow && <Form.Control as={DatePicker}
						selected={publishDate}
						onChange={(date: unknown) => setPublishDate(new Date(date as Date))}
						showTimeInput
						dateFormat="Pp"
						required
						inline />}
				</Form.Group>
				<Form.Group controlId="image" className="mb-3" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
					<Form.Label>Image</Form.Label>
					<Form.Check
						type={'checkbox'}
						label={`Include Image`}
						checked={enableImage}
						onChange={(e) => setEnableImage(e.target.checked)}
					/>
					{enableImage && <img width={400} src={image} alt="" />}
					{enableImage && <Form.Control type="file" onChange={onFileChange} />}
				</Form.Group>
				<Button variant="primary" type="submit">
					Create
				</Button>
			</Form>
		</div>
	);
}
